import { __rest, __assign } from 'tslib';
import React, { forwardRef } from 'react';
import { useMatchMedia } from '@alfalab/core-components-mq/esm';
import { ButtonDesktop } from './Component.desktop.js';
import { ButtonMobile } from './Component.mobile.js';
import './components/base-button/Component.js';
import 'react-merge-refs';
import 'classnames';
import '@alfalab/core-components-shared/esm';
import '@alfalab/core-components-spinner/esm';
import '@alfalab/hooks';

var Button = forwardRef(function (_a, ref) {
    var children = _a.children, _b = _a.breakpoint, breakpoint = _b === void 0 ? 1024 : _b, restProps = __rest(_a, ["children", "breakpoint"]);
    var query = "(min-width: ".concat(breakpoint, "px)");
    var isDesktop = useMatchMedia(query)[0];
    var Component = isDesktop ? ButtonDesktop : ButtonMobile;
    return (React.createElement(Component, __assign({ ref: ref }, restProps), children));
});

export { Button };
